var styles = {"box":"GradientWrapper_box_11r3l_1","full":"GradientWrapper_full_11r3l_10","mask":"GradientWrapper_mask_11r3l_13"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
